const testIds = {
  root: 'slider-root',
  renderedImage: 'slider-rendered-image',
  playIcon: 'play-icon',
  videoWrapper: 'video-wrapper',
};

export default testIds;
